import React from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

// Components
import CustomerLockoutsHeader from "./CustomerLockoutsHeader";
import CustomerLockoutsBody from "./CustomerLockoutsBody";

// This component will hold the latest leads data
const CustomerLockoutsTable = ({ lockoutData, totalLockouts, setTrigger, userId, role, open }) => {
  return (
    <div className={`${open ? "show-table" : "hide-table"}`}>
      <h4 className="aggregated-report-count">
        Total Lockouts {totalLockouts}
      </h4>
      <TableContainer>
        <Table className="table">
          <CustomerLockoutsHeader />
          <CustomerLockoutsBody 
            lockoutData={lockoutData}
            setTrigger={setTrigger}
            userId={userId}
            role = {role}
           />
        </Table>
      </TableContainer>
      <div className="bottom-footer"></div>
    </div>
  );
};

export default CustomerLockoutsTable;
